import { createContext, useContext, FC, ReactNode } from "react";
import type { CrawlerFormData } from "pages/crawler/types";
import { useCrawlerCostEstimate } from "pages/crawler/hooks/useCrawlerCostEstimate";

interface CrawlerCostContextValue {
  /** Estimated cost per request; defaults to 1 until an estimate is available. */
  costPerRequest: number;
  costLoading: boolean;
  /** Standard price to warn about when the start URL's domain is on a legacy rate (ENG-1112); undefined otherwise. */
  legacyStandardCredits: number | undefined;
}

const CrawlerCostContext = createContext<CrawlerCostContextValue | undefined>(undefined);

export const CrawlerCostProvider: FC<{ formValues: CrawlerFormData; children: ReactNode }> = ({
  formValues,
  children,
}) => {
  const value = useCrawlerCostEstimate(formValues);
  return <CrawlerCostContext.Provider value={value}>{children}</CrawlerCostContext.Provider>;
};

export const useCrawlerCostContext = (): CrawlerCostContextValue => {
  const context = useContext(CrawlerCostContext);
  if (!context) {
    throw new Error("useCrawlerCostContext must be used within a CrawlerCostProvider");
  }
  return context;
};
